// @flow
import client from '../../client'
import jwt from '../../utils/jwt'
import format from '../../utils/format'

// Constants
export const GET_PROFILE_ENDPOINT = '/auth/users/{0}/'

/**
 * Get corporate user from local storage
 * @return {Promise|Error} A resolved Promise with the server response or Rejected with an Error
 */
export const getProfile = (): Promise<any> => {
  const userId = jwt.getAuthorizedUserId()
  if (!userId) return Promise.reject(new Error('Invalid token specified'))

  const endpoint = format(GET_PROFILE_ENDPOINT, userId)
  return client.get(endpoint, {})
}

export default getProfile
